import type { BleCapability } from './provisioning-types';

/**
 * Feature-detect Web Bluetooth. Improv-basert BLE-provisjonering kjører kun
 * via `navigator.bluetooth` (Chrome/Edge på desktop + Chrome på Android).
 *
 * Vi trenger ikke native-grener her: infoskjerm-seksjonen er skjult i native-
 * appen (d-page-menu: `isAppPlatform`), så dialogen er kun nåbar på web. iOS
 * (Safari/WebKit) mangler Web Bluetooth → captive-portal er fallback der.
 */
export function detectBleCapability(): BleCapability {
  if (typeof navigator !== 'undefined' && 'bluetooth' in navigator && navigator.bluetooth) {
    return 'web-bluetooth';
  }
  return 'unsupported';
}

/** True hvis vi faktisk kan kjøre provisjonerings-flyten i dette miljøet. */
export function isBleProvisioningSupported(capability: BleCapability): boolean {
  return capability === 'web-bluetooth';
}
